import {TableFixedColumns} from '@devexpress/dx-react-grid-material-ui';

import {cellStyle} from './OptixTableBase';

export function TableFixedColumnsCell(
  props: TableFixedColumns.CellProps,
): JSX.Element {
  return <TableFixedColumns.Cell style={cellStyle} {...props} />;
}
